import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  isNumber,
  removeThousandSeparotors,
} from "../../../../utils/formValidations";

function PriceFilter() {
  const [searchParams, setSearchParams] = useSearchParams();
  const minPriceQueryVal = searchParams.get("min") || "";
  const maxPriceQueryVal = searchParams.get("max") || "";
  const [minPrice, setMinPrice] = useState<string>(
    minPriceQueryVal === "" ? "" : Number(minPriceQueryVal).toLocaleString()
  );
  const [maxPrice, setMaxPrice] = useState<string>(
    maxPriceQueryVal === "" ? "" : Number(maxPriceQueryVal).toLocaleString()
  );

  function handleInput(
    e: React.ChangeEvent<HTMLInputElement>,
    setter: React.Dispatch<React.SetStateAction<string>>
  ) {
    let raw = e.target.value.replaceAll(",", "");
    if (raw === "") { setter(""); return; }
    if (isNumber(raw)) setter(Number(raw).toLocaleString());
  }

  function handleApplyBtn() {
    setSearchParams((prev) => {
      const newParams = new URLSearchParams(prev);
      if (minPrice === "") newParams.delete("min");
      else newParams.set("min", removeThousandSeparotors(minPrice).toString());
      if (maxPrice === "") newParams.delete("max");
      else newParams.set("max", removeThousandSeparotors(maxPrice).toString());
      return newParams;
    });
  }

  return (
    <div>
      <p style={{
        fontSize: "0.6875rem", fontWeight: 700, letterSpacing: "0.07em",
        textTransform: "uppercase", color: "#94a3b8", marginBottom: "1rem",
        paddingBottom: "0.5rem", borderBottom: "1px solid #f1f5f9",
      }}>
        Price Range (LKR)
      </p>

      <div className="mb-3">
        <label style={{ fontSize: "0.8125rem", color: "#64748b", display: "block", marginBottom: "0.3rem" }}>
          Min Price
        </label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={minPrice}
          onChange={(e) => handleInput(e, setMinPrice)}
          placeholder="0"
        />
      </div>

      <div className="mb-3">
        <label style={{ fontSize: "0.8125rem", color: "#64748b", display: "block", marginBottom: "0.3rem" }}>
          Max Price
        </label>
        <input
          type="text"
          className="form-control form-control-sm"
          value={maxPrice}
          onChange={(e) => handleInput(e, setMaxPrice)}
          placeholder="Any"
        />
      </div>

      <button
        type="button"
        className="btn btn-danger btn-sm w-100 fw-bold"
        style={{ borderRadius: "50rem" }}
        onClick={handleApplyBtn}
      >
        Apply Filter
      </button>
    </div>
  );
}

export default PriceFilter;
